export default "__VITE_ASSET__B8LiW0qc__"